// Glossary tooltips (snippets/ec-glossary-tip.liquid, guidelines §5.6).
// Desktop: open on hover and on keyboard focus. Touch: open on tap, close on tap outside.
// Escape closes an open tooltip first (before the filter sheet). The bubble is placed against the
// viewport and flips below / shifts sideways near the screen edges.

const MARGIN = 12
const GAP = 8
const hoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)')

function bubbleFor(trigger) {
  return document.getElementById(trigger.getAttribute('aria-describedby'))
}

// Outside the filter sheet the bubble is moved to <body> while open: the chip row's edge fade
// (mask-image) would otherwise clip it. Inside the sheet (a top-layer dialog) it stays put.
const homes = new WeakMap()

function detach(trigger, bubble) {
  if (trigger.closest('dialog') || bubble.parentElement === document.body) return
  homes.set(bubble, bubble.parentElement)
  document.body.appendChild(bubble)
}

function reattach(bubble) {
  const home = homes.get(bubble)
  if (!home) return
  homes.delete(bubble)
  if (home.isConnected) {
    home.appendChild(bubble)
  } else {
    bubble.remove()
  }
}

function place(trigger, bubble) {
  bubble.style.left = '0px'
  bubble.style.top = '0px'
  // Offset of the containing block (the glass sheet creates its own, for example)
  const origin = bubble.getBoundingClientRect()
  const t = trigger.getBoundingClientRect()
  const b = bubble.getBoundingClientRect()

  let placement = 'top'
  let top = t.top - b.height - GAP
  if (top < MARGIN) {
    placement = 'bottom'
    top = t.bottom + GAP
  }
  let left = t.left + t.width / 2 - b.width / 2
  left = Math.max(MARGIN, Math.min(left, window.innerWidth - b.width - MARGIN))

  bubble.style.left = `${left - origin.left}px`
  bubble.style.top = `${top - origin.top}px`
  bubble.dataset.placement = placement
  bubble.style.setProperty('--ec-tip-arrow-x', `${t.left + t.width / 2 - left}px`)
}

function open(trigger, pinned = false) {
  const bubble = bubbleFor(trigger)
  if (!bubble) return
  closeAll(trigger)
  detach(trigger, bubble)
  bubble.hidden = false
  trigger.setAttribute('aria-expanded', 'true')
  if (pinned) trigger.dataset.pinned = 'true'
  place(trigger, bubble)
}

function close(trigger) {
  const bubble = bubbleFor(trigger)
  if (bubble) {
    bubble.hidden = true
    reattach(bubble)
  }
  trigger.setAttribute('aria-expanded', 'false')
  delete trigger.dataset.pinned
}

function closeAll(except = null) {
  document.querySelectorAll('[data-ec-tip][aria-expanded="true"]').forEach((trigger) => {
    if (trigger !== except) close(trigger)
  })
}

if (!window.ecGlossaryTipsReady) {
  window.ecGlossaryTipsReady = true

  document.addEventListener('click', (evt) => {
    const trigger = evt.target.closest('[data-ec-tip]')
    if (!trigger) {
      closeAll()
      return
    }
    evt.preventDefault()
    if (trigger.getAttribute('aria-expanded') === 'true' && trigger.dataset.pinned) {
      close(trigger)
    } else {
      open(trigger, true)
    }
  })

  document.addEventListener('mouseover', (evt) => {
    if (!hoverDevice.matches) return
    const trigger = evt.target.closest('[data-ec-tip]')
    if (trigger && trigger.getAttribute('aria-expanded') !== 'true') open(trigger)
  })

  document.addEventListener('mouseout', (evt) => {
    if (!hoverDevice.matches) return
    const trigger = evt.target.closest('[data-ec-tip]')
    if (trigger && !trigger.contains(evt.relatedTarget) && !trigger.dataset.pinned && document.activeElement !== trigger) {
      close(trigger)
    }
  })

  document.addEventListener('focusin', (evt) => {
    const trigger = evt.target.closest?.('[data-ec-tip]')
    if (trigger) open(trigger)
  })

  document.addEventListener('focusout', (evt) => {
    const trigger = evt.target.closest?.('[data-ec-tip]')
    if (trigger && !trigger.dataset.pinned) close(trigger)
  })

  // Escape closes the tooltip before anything else (e.g. the filter sheet)
  document.addEventListener(
    'keydown',
    (evt) => {
      if (evt.key !== 'Escape') return
      const openTrigger = document.querySelector('[data-ec-tip][aria-expanded="true"]')
      if (!openTrigger) return
      evt.preventDefault()
      evt.stopPropagation()
      close(openTrigger)
    },
    true
  )

  window.addEventListener('resize', () => closeAll())
  document.addEventListener('scroll', () => closeAll(), true)
}
